import React from "react";
import { useContext } from "react";
import { useLocation } from "react-router-dom";
import "../assets/css/CCmenu.css";
import Contexto from "../context/Contexto";
import { useEffect } from "react";
import { useState } from "react";
import MiCurso from "../components/MiCurso";
import { Link } from "react-router-dom";
import Play from "../assets/CCstatics/play.png";
import Nuevo from "../assets/CCstatics/nuevito.png";
import Descarga from "../assets/CCstatics/descarga.png";

function Escuela() {
  const location = useLocation();

  const { productos, colorClub, traemeColorClub, cursoscomprados } =
    useContext(Contexto);

  useEffect(() => {
    if (cursoscomprados.hasOwnProperty("color-club")) {
      traemeColorClub();
    }
  }, [cursoscomprados]);
  const [escuelaActual, setEscuelaActual] = useState(null);
  const [tutoriales, setTutoriales] = useState([]);
  const [presets, setPresets] = useState([]);

  window.scrollTo(0, 0);

  useEffect(() => {
    //Busco en el array un objeto con el nombre que viene por url
    let resultado = colorClub.find(
      (element) => element.url === location.pathname.substring(9)
    );

    // let path = location.pathname.split("/");

    // //SI no es un curso a 404
    // if (resultado === undefined && productos.length > 0 && path[1] != "ver") {
    //   console.log("a donde vamos che");
    // }
    setEscuelaActual(resultado);
    if (colorClub) {
      if (resultado) {
        let nombreTuto = `tutoriales${resultado.url}`;
        setTutoriales(colorClub[8][nombreTuto]);
      }
    }

    ///si es la escuela de presets busco los presets
    if (colorClub) {
      if (resultado && resultado.url == "presets") {
        setPresets(colorClub[7].presets);
      }
    }
  }, [colorClub]);

  return (
    <>
      <div className="colorClubContenedor">
        {escuelaActual && (
          <>
            <div className="escuelaSoporte">
              <Link to="/miscursos"> &#60; Volver a Color Club </Link>
              <br /> <br />
              <div
                className="escuelaNombre"
                style={{
                  color: `${escuelaActual.color}`,
                }}
              >
                <p>{escuelaActual.nombre}</p>
                <br />
              </div>
              {presets.length < 1 && <p class="titulitou">Cursos</p>}
              {escuelaActual.cursos &&
                escuelaActual.cursos.map((item, i) => {
                  return (
                    <>
                      <MiCurso
                        escuela={escuelaActual.url}
                        color={escuelaActual.color}
                        info={item.data}
                        key={i}
                        curso={item.data.url}
                      />{" "}
                      <br />
                    </>
                  );
                })}
              <p className="capitalize titulitou">
                Tutoriales {escuelaActual.url}
              </p>
              {tutoriales &&
                tutoriales.map((item, i) => {
                  if (i > 1) {
                    return (
                      <Link
                        to={`/ver/color-club/${escuelaActual.url}/tutoriales${
                          escuelaActual.url
                        }/${i - 1}`}
                        className=""
                      >
                        <div
                          key={`${i}tutoriales`}
                          className="tutoriales"
                          style={{
                            background: escuelaActual.color2,
                          }}
                        >
                          <p className="tutotit"> {item.nombre}</p>
                          {item.nuevo && (
                            <img src={Nuevo} alt="Nuevo" className="nuevito" />
                          )}
                          <div className="cositas">
                            <span className="blanco"> VER </span>
                            <img src={Play} alt="" />
                          </div>
                        </div>{" "}
                      </Link>
                    );
                  }
                })}
              {/* //////////////////////// */}
              {presets.length > 0 && <p>Presets</p>}
              {presets &&
                presets.map((item, i) => {
                  return (
                    <Link to={item.url}>
                      <div
                        key={`${i}tutoriales`}
                        className="tutoriales"
                        style={{
                          background: "#FFBF21",
                        }}
                      >
                        <p>{item.nombre}</p>
                        <div className="cositas">
                          <span className="blanco"> Descargar </span>
                          <img src={Descarga} alt="" />
                        </div>
                      </div>{" "}
                    </Link>
                  );
                })}
              <br />
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default Escuela;
